import { useSubscriptionStatus } from '../useSubscriptionStatus';
import SubscriptionGuard from '../SubscriptionGuard';
import FastFoodCore from './FastFoodCore';
import FastFoodLandingPage from './FastFoodLandingPage';

export default function FastFoodApp() {
  const { status, daysLeft, expiresAtLabel } = useSubscriptionStatus('fastfood_pos_v1');

  return (
    <SubscriptionGuard status={status} daysLeft={daysLeft} expiresAtLabel={expiresAtLabel} landing={<FastFoodLandingPage />} appKey={"fastfood_pos_v1"} appName={"POS Comida Rápida"}>
      <FastFoodCore />
    </SubscriptionGuard>
  );
}
